export default {
  header: {
    title: 'Cod promoțional sau card cadou',
  },
  available_codes: {
    title_one: 'Cod disponibil ({{count}})',
    title_few: 'Coduri disponibile ({{count}})',
    title_other: 'Coduri disponibile ({{count}})',
    min_threshold: 'Min {{value}}',
    percentage_off: '{{discount}}% reducere la această comandă',
    amount_off: '{{amount}} reducere la această comandă',
  },
  content: {
    input: {
      placeholder: 'Introdu un cod',
    },
    buttons: {
      done: 'Gata',
      apply: 'Aplică',
      applied: 'Aplicat ✓',
    },
  },
};
